import { Fragment, h } from 'preact';

import { getLabel } from '../../../../labels/labelling-service';
import { isMobile } from '../../../../utils/device-utils';
import Option from '../../../components/2-atoms/option/option';
import SkyItBox from '../../../components/3-molecules/sky-it-box/sky-it-box';
import SkyItModalWithPanel from '../../../components/3-molecules/sky-it-modal-with-panel/sky-it-modal-with-panel';
import SkyItPanel from '../../../components/3-molecules/sky-it-panel/sky-it-panel';

const renderNewsletters = ({ htmlProps, state, handlers, blockType }) =>
  (htmlProps.newsLetters || []).map((newsletter) => {
    const card = {
      newsData: {
        title: newsletter.title,
        abstract: newsletter.description,
        urlImage: newsletter.urlImage,
      },
      modifiers: ['CA25-m', 'CA15-t', 'CA15-d', 'base'],
    };

    return (
      <Option
        key={newsletter.id}
        isActive={state.selectedOptionsIds.includes(newsletter.id)}
        modifiers={['radio', 'sky-it-card']}
        card={card}
        onClick={() => handlers.handleOptionInPageClick(newsletter, blockType)}
      />
    );
  });

export const renderInPage = ({ htmlProps, state, handlers, elementIdInPage, isActiveInPage, blockType }) => {
  const mailSkyId = state.dataSubscriptions.mailSkyId;

  return (
    <div
      id={elementIdInPage}
      className="c-user-preferences__newsletters c-user-preferences__widget"
      data-state={isActiveInPage ? 'active' : ''}
    >
      <SkyItBox title={htmlProps.title} description={htmlProps.description} onInfoClick={handlers.handleInfoClick}>
        {isMobile() && (
          <Fragment>
            <button
              className="c-cta c-cta--sky-it-primary"
              type="button"
              onClick={handlers.handleOpenNewslettersFullScreen}
            >
              <span className="c-cta__text">{getLabel('newsletters.select.label')}</span>
            </button>
            {state.showNewslettersFullScreen && (
              <div className="c-user-preferences__newsletters-full-screen">
                <div className="c-user-preferences__newsletters-full-screen-header">
                  <button className="c-cta--close" type="button" onClick={handlers.handleCloseNewslettersFullScreen}>
                    <div>
                      <div />
                    </div>
                  </button>
                </div>
                {renderNewsletters({ htmlProps, state, handlers, blockType })}
              </div>
            )}
          </Fragment>
        )}
        {!isMobile() && (
          <div className="c-sky-it-box__scrollable-content">
            {renderNewsletters({ htmlProps, state, handlers, blockType })}
          </div>
        )}
        <div className="c-sky-it-box__footer">
          {mailSkyId && (
            <p
              dangerouslySetInnerHTML={{
                __html: htmlProps.footer.title.replace('%s', mailSkyId),
              }}
            />
          )}
          <p
            className="c-sky-it-box__footer-disclaimer-text"
            dangerouslySetInnerHTML={{ __html: htmlProps.footer.subtitle }}
          />
        </div>
      </SkyItBox>

      <SkyItModalWithPanel onCancel={handlers.handleUnsubscribeModalClose} isActive={state.showUnsubscribeModal}>
        <SkyItPanel
          title={htmlProps.modalUnsubscribe.title}
          description={htmlProps.modalUnsubscribe.description}
          ctaPrimaryLabel={htmlProps.modalUnsubscribe.ctaPrimaryLabel}
          onCtaPrimaryClick={handlers.handleUnsubscribeModalClose}
        />
      </SkyItModalWithPanel>
    </div>
  );
};
